const openAIProperties = [

  {destination: 'enable_search', origin: '', isRequired: true},
  {destination: 'enable_checkout', origin: '', isRequired: true},
  {destination: 'id', origin: 'sku', isRequired: true},
  {destination: 'gtin', origin: '', isRequired: false},
  {destination: 'mpn', origin: '', isRequired: false},
  {destination: 'title', origin: '', isRequired: true},
  {destination: 'description', origin: '', isRequired: true},
  {destination: 'link', origin: '', isRequired: true},
  {destination: 'condition', origin: '', isRequired: true},
  {destination: 'product_category', origin: '', isRequired: true},
  {destination: 'brand', origin: '', isRequired: false},
  {destination: 'material', origin: '', isRequired: true},
  {destination: 'dimensions', origin: '', isRequired: false},
  {destination: 'lenght', origin: '', isRequired: false},
  {destination: 'width', origin: '', isRequired: false},
  {destination: 'height', origin: '', isRequired: false},
  {destination: 'weight', origin: '', isRequired: true},
  {destination: 'age_group', origin: '', isRequired: false},
  {destination: 'image_link', origin: '', isRequired: true},
  {destination: 'additional_image_link', origin: '', isRequired: false},
  {destination: 'video_link', origin: '', isRequired: false},
  {destination: 'model_3d_link', origin: '', isRequired: false},
  {destination: 'price', origin: '', isRequired: true},
  {destination: 'sale_price', origin: '', isRequired: false},
  {destination: 'applicable_taxes_fees', origin: '', isRequired: false},
  {destination: 'sale_price_effective_date', origin: '', isRequired: false},
  {destination: 'unit_pricing_measure', origin: '', isRequired: false},
  {destination: 'pricing_trend', origin: '', isRequired: false},
  {destination: 'availability', origin: '', isRequired: true},
  {destination: 'availability_date', origin: '', isRequired: false},
  {destination: 'inventory_quantity', origin: '', isRequired: true},
  {destination: 'expiration_date', origin: '', isRequired: false},
  {destination: 'pickup_method', origin: '', isRequired: false},
  {destination: 'pickup_sla', origin: '', isRequired: false},
  {destination: 'item_group_id', origin: '', isRequired: false},
  {destination: 'item_group_title', origin: '', isRequired: false},
  {destination: 'color', origin: '', isRequired: false},
  {destination: 'size', origin: '', isRequired: false},
  {destination: 'size_system', origin: '', isRequired: false},
  {destination: 'gender', origin: '', isRequired: false},
  {destination: 'offer_id', origin: '', isRequired: false},
  {destination: 'Custom_varian1_category', origin: '', isRequired: false},
  {destination: 'Custom_varian1_option', origin: '', isRequired: false},
  {destination: 'Custom_varian2_category', origin: '', isRequired: false},
  {destination: 'Custom_varian2_option', origin: '', isRequired: false},
  {destination: 'Custom_varian3_category', origin: '', isRequired: false},
  {destination: 'Custom_varian3_option', origin: '', isRequired: false},
  {destination: 'shipping', origin: '', isRequired: false},
  {destination: 'delivery_estimate', origin: '', isRequired: false},
  {destination: 'seller_name', origin: '', isRequired: true},
  {destination: 'seller_url', origin: '', isRequired: true},
  {destination: 'seller_privacy_policy', origin: '', isRequired: true},
  {destination: 'seller_tos', origin: '', isRequired: true},
  {destination: 'return_policy', origin: '', isRequired: true},
  {destination: 'return_window', origin: '', isRequired: true},
  {destination: 'popularity_score', origin: '', isRequired: false},
  {destination: 'return_rate', origin: '', isRequired: false},
  {destination: 'warning', origin: '', isRequired: false},
  {destination: 'warning_url', origin: '', isRequired: false},
  {destination: 'age_restriction', origin: '', isRequired: false},
  {destination: 'product_review_count', origin: '', isRequired: false},
  {destination: 'product_review_rating', origin: '', isRequired: false},
  {destination: 'store_review_count', origin: '', isRequired: false},
  {destination: 'store_review_rating', origin: '', isRequired: false},
  {destination: 'q_and_a', origin: '', isRequired: false},
  {destination: 'raw_review_data', origin: '', isRequired: false},
  {destination: 'related_product_id', origin: '', isRequired: false},
  {destination: 'relationship_type', origin: '', isRequired: false},
  {destination: 'geo_price', origin: '', isRequired: false},
  {destination: 'geo_availability', origin: '', isRequired: false},
]


export default openAIProperties;
